"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var _styledTools = require("styled-tools");

var _arrows = _interopRequireDefault(require("./icons/arrows.svg"));

const thumbStyle = props => (0, _stylitas.css)`
  appearance: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${(0, _styledTools.theme)('colorNeutralWhite')(props)};
  background-image: url(${_arrows.default});
  background-repeat: no-repeat;
  background-position: center center;
  box-shadow: 0px -2px 16px rgba(0, 0, 0, 0.04),
    0px 4px 24px rgba(0, 0, 0, 0.08);
  margin-top: -20px;
  cursor: pointer;
  outline: none;
  border: none;
  position: relative;

  ${_styleUtilities.media.md`
    width: 48px;
    height: 48px;
    margin-top: -24px;
  `}
`;

const thumb = props => (0, _stylitas.css)`
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    ${thumbStyle(props)}
  }

  &::-moz-range-thumb {
    -moz-appearance: none;
    ${thumbStyle(props)}
  }

  &::-ms-thumb {
    ${thumbStyle(props)}
  }
`;

const trackStyle = props => (0, _stylitas.css)`
  width: 100%;
  height: 1px;
  cursor: pointer;
  background: linear-gradient(
    to right,
    ${(0, _styledTools.theme)('colorNeutral90')(props)} 0%,
    ${(0, _styledTools.theme)('colorNeutral90')(props)} ${(0, _styledTools.prop)('filled')(props)}%,
    ${(0, _styledTools.theme)('colorNeutral15')(props)} ${(0, _styledTools.prop)('filled')(props)}%,
    ${(0, _styledTools.theme)('colorNeutral15')(props)} 100%
  );
`;

const track = props => (0, _stylitas.css)`
  &::-webkit-slider-runnable-track {
    ${trackStyle(props)}
  }

  &::-moz-range-track {
    ${trackStyle(props)}
  }

  &::-ms-track {
    ${trackStyle(props)}
  }
`;

const StyledInput = _stylitas.styled.input`
  -webkit-appearance: none;
  width: 100%;
  height: auto;
  min-height: 60px;
  background: transparent;
  outline: none;
  overflow: visible;

  ${thumb}
  ${track}
`;
exports.Input = StyledInput;